export default "__VITE_ASSET__kOIVLhw$__"